import { useTranslation } from 'react-i18next';

/**
 * GeneratingStep
 *
 * Loading state shown while AI is generating content from the briefing.
 * Displays an animated spinner with encouraging messages.
 */
export function GeneratingStep() {
  const { t } = useTranslation('ai');

  return (
    <div className="flex flex-col items-center justify-center py-16 space-y-6">
      {/* Animated Spinner */}
      <div className="relative">
        {/* Background circle */}
        <div className="w-16 h-16 border-4 border-primary-200 rounded-full" />
        {/* Spinning border */}
        <div className="absolute top-0 w-16 h-16 border-4 border-primary-500 border-t-transparent rounded-full animate-spin" />
      </div>

      {/* Message */}
      <div className="text-center space-y-2">
        <p className="text-lg font-medium text-gray-900">
          {t('ai_briefing_generating_title')}
        </p>
        <p className="text-sm text-gray-500">
          {t('ai_briefing_generating_message')}
        </p>
      </div>

      {/* Subtle pulsing dots animation */}
      <div className="flex items-center space-x-2">
        <div className="w-2 h-2 bg-primary-500 rounded-full animate-pulse" style={{ animationDelay: '0ms' }} />
        <div className="w-2 h-2 bg-primary-500 rounded-full animate-pulse" style={{ animationDelay: '150ms' }} />
        <div className="w-2 h-2 bg-primary-500 rounded-full animate-pulse" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  );
}
